export default "/react/logoSupa-c1a24bfc.png";